import React from 'react';
import FamilyCard from './FamilyCard';

const body = [
  'Dr. Yuki Tanaka proved that consciousness was a quantum phenomenon — the discovery that made the upload procedure possible. Her family became the <strong class="text-white">engineering spine of the solar civilization</strong>: the Tanaka-Osei Reactor achieved sustained fusion in 2087.',
  'Descendants managed the Helios Array, directed Atmospheric Harvesting on Jupiter, and raised children in Valhalla Station\'s low-gravity corridors. The Tanakas thought in systems. They asked not <em>what is possible</em> but <em>what holds</em>.',
  'Mercury\'s underground cities, Jupiter\'s He-3 extraction fleet, Triton Station\'s deep-space listening arrays — the infrastructure of the solar civilization bears, invisibly, their handwriting.',
];

const FamilyTanaka = () => (
  <FamilyCard
    id="family-1"
    accentColor="text-orange-400"
    dotColor="bg-orange-400"
    borderColor="border-orange-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-orange-900/10 via-transparent to-transparent"
    tag="The Engineers · Mercury / Inner System"
    name="The Tanakas"
    origin="Mercury · Valhalla Station · Jupiter System"
    role="The Engineers"
    body={body}
    quote="My daughter, the astronomer. When I was your age, I was trying to figure out how to get the WiFi to reach my bedroom."
    quoteSource="Hiroshi Tanaka-Mwangi, Valhalla Station, 2501"
  />
);

export default FamilyTanaka;